import React, { forwardRef, useEffect, useState } from 'react';
import ReCAPTCHA, { type ReCAPTCHAProps } from 'react-google-recaptcha';

export type ReCAPTCHAType = ReCAPTCHA;

export const AccessibleReCAPTCHA = forwardRef<ReCAPTCHAType, ReCAPTCHAProps>((
	{
		onChange: onChangeProp,
		...otherProps
	},
	recaptchaRef,
) => {
	const [isChanged, setIsChanged] = useState(false);

	useEffect(() => {
		// Find the textarea and add aria-label
		const textarea = document.querySelector('textarea#g-recaptcha-response');
		if (textarea) {
			// textarea.setAttribute('aria-label', 'Google reCAPTCHA response field');
			textarea.setAttribute('aria-label', 'Google reCAPTCHA svar felt');
		}
	}, [isChanged]);

	return (
		<div className="flex justify-start t p-4">
			<ReCAPTCHA
				{...otherProps}
				onChange={(token) => {
					setIsChanged(true);
					if (onChangeProp) onChangeProp(token);
				}}
				ref={recaptchaRef}
			/>
		</div>
	);
});
